import { Injectable } from '@angular/core';
import { AbstractResetAccountService } from './abstract-resetAcountService';
import { UserModel } from '../../../shared/model/userModel';
import 'rxjs/add/observable/of';
import { environment } from '../../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ResetAccountMockService implements AbstractResetAccountService {

  constructor(private http: HttpClient) { }

  resetAccount(userModel: UserModel): Observable<any>{
      return Observable.of({});
    }

}


// WEBPACK FOOTER //
// ./src/app/account/resetAccount/services/resetAccountMock.service.ts